
<template>

  <div class="card card-front front-card">
    <div class="card card-front settings-card" v-if="!deletePrimed && !changePrimed">
      <div class="close-card" @click="$emit('initFlip', {from: 'settings', to: 'front'})">
        <h6>x</h6>
      </div>
      <header class="card-header settings-card-header settings-title-header">
        <h4>{{room.info.hvacName}}</h4>
        <div class="settings-title-seperator"></div>
        <h4 style="color:lightblue;font-weight:lighter;">{{clauses.fChanged}}: {{changed}}</h4>
      </header>
      <header class="card-header settings-card-header">
        <h4>{{clauses.actions}}</h4>
      </header>
      <a class="land-btn prim-btn" @click="changePrimed = true">{{clauses.changeFilter}}</a>
      <a class="land-btn alert-btn" @click="deletePrimed = true">{{clauses.delRoom}}</a>
      <header class="card-header settings-card-header" style="margin-top:10%;">
        <h4>{{clauses.settings}}</h4>
      </header>
      <a class="land-btn sec-btn" @click="$emit('initFlip', {from: 'settings', to: 'setpoints'})">{{clauses.alertSP}}</a>
      <!-- <a class="land-btn sec-btn" style="background:gray;cursor:default;border:none;">
        <v-popover style="width:100%;" offset="3" trigger="hover" placement="bottom">
          {{clauses.alertSP}}
          <template slot="popover">
              <hover-component :options="{type: 'mini', text: 'Disabled During Run-in Phase'}"></hover-component>
          </template>
        </v-popover> -->
      </a>
    </div>
    <div class="card card-front settings-card" v-if="deletePrimed">
      <header class="card-header settings-card-header settings-title-header">
        <h4>{{room.info.hvacName}}</h4>
      </header>
      <div class="card-del-input">
        <input class="ob-input" v-model="delName" :placeholder="clauses.rName" />
        <label class="ob-label">{{clauses.delLabel}}</label>
      </div>
      <a class="land-btn sec-btn" @click="deletePrimed = false">{{clauses.cancel}}</a>
      <a class="land-btn prim-btn" v-if="delName == room.info.hvacName" @click="confirmRoomDel">{{clauses.conf}}</a>
    </div>
    <div class="card card-front settings-card" v-if="changePrimed">
      <header class="card-header settings-card-header settings-title-header">
        <h4>{{room.info.hvacName}}</h4>
      </header>
      <div class="card-del-input">
        <input class="ob-input" v-model="confChange" :placeholder="clauses.conf" />
        <label class="ob-label">{{clauses.changeLabel}}</label>
      </div>
      <a class="land-btn sec-btn" @click="changePrimed = false">{{clauses.cancel}}</a>
      <a class="land-btn prim-btn" v-if="confChange.toLowerCase() == 'confirm'" @click="changeFilter">{{clauses.conf}}</a>
    </div>
  </div>

</template>

<script>

import Lang from '@/lib/langTemplates/CardTemplate';
import Hover from '../hover/Hover';

import moment from 'moment';

export default {

  data(){
    return {
      deletePrimed: false,
      delName: '',
      changePrimed: false,
      confChange: '',
      changed: ''
    }
  },

  props: ['room'],

  components: {
    'hover-component': Hover
  },

  computed: {
    clauses(){
      let lPref = this.$store.state.lang;
      return Object.keys(Lang.clauses).reduce((a, i) => {
        a[i] = Lang.clauses[i][lPref];
        return a;
      }, {});
    }
  },

  methods: {

    async changeFilter(){
      const changed = await this.$store.dispatch('changeFilter', this.room.airVentId);
      this.changePrimed = false;
      this.changed = this.setChanged(changed);
    },

    setChanged(){
      return moment(this.room.lastChanged * 1000).format('MMM-DD YYYY')
    },

    confirmRoomDel(){
      this.$store.dispatch('deleteRoom', {did: this.room.did, breakpoint: this.$screen.breakpoint});
      this.$emit('initFlip', {from: 'settings', to: 'front'});
    }

  },

  mounted(){
    this.changed = this.setChanged(this.room.lastChanged);
  }

}

</script>

<style>

.settings-card {
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.settings-card-header {
  width: 90%;
  border-bottom: 1px solid gray;
  margin-bottom: 10px;
}

.settings-card-header h4 {
  color: gray;
  width: 100%;
  text-align: left;
  margin: 3px;
}

.settings-card .land-btn {
  width: 90%;
  margin: 3px;
}

.close-card {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 2%;
  left: 2%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.close-card h6 {
  color: rgb(0, 153, 191);
  font-size: 1.1em;
}

.close-card h6:hover {
  font-size: 1.3em;
}

.card-del-input {
  width: 100%;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.ob-del-input label {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.settings-title-header {
  width: 70%;
  padding: 4px;
  border-bottom: 4px solid rgb(0, 153, 191);
  margin-top: 20%;
  margin-bottom: 20%;
}

.settings-title-header h4 {
  color: rgb(0, 153, 191);
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/card/Settings.vue